<template>
  <div>
    <!--<div class="products-page">-->
      <!--<div class="box-header p-b-0 white">-->
        <!--<div class="row">-->
          <!--<div class="col-sm-12 col-md-4">-->
            <!--<div class="block text-u-c h3 _300 m-t-xs">Products</div>-->
          <!--</div>-->
          <!--<div class="col-sm-12 col-md-8 hidden-sm">-->

            <!--<div class="pull-right">-->
              <!--<button class="btn btn-outline p-t-xs no-radius no-bg">-->
                <!--<i class="fa fa-sort-amount-desc"></i>-->
              <!--</button>-->
            <!--</div>-->

            <!--&lt;!&ndash; Search &ndash;&gt;-->
            <!--<div class="input-group w-lg pull-right" style="width: 250px;">-->
              <!--<span class="input-group-addon text-muted no-border no-bg">-->
                <!--<i class="fa fa-search"></i>-->
              <!--</span>-->
              <!--<div class="organization-search">-->
                <!--<form novalidate>-->
                  <!--<input type="text" name="searchTerm" placeholder="Search products..."-->
                         <!--class="form-control no-border no-bg">-->
                <!--</form>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div v-if="product">
      <div class="container product-full-view-container">
        <div class="product-full-view">
          <div class="m-b">
            <div @click="goBack()" class="go-back-btn text-u-c">&lt; Back</div>
            <product-full-view v-if="product" :product="product"></product-full-view>
          </div>
        </div>
      </div>
      <hr class="horizontal-line-above-tabset block" />

      <ul class="nav nav-tabs">
        <li class="active"><a class="product--info m-n" data-toggle="tab" href="#product_info">Product Info</a></li>
        <li><a class="product--info" data-toggle="tab" href="#product_specs">Product Specs</a></li>
      </ul>
      <div class="tab-content">
        <div id="product_info" class="tab-pane fade in active">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <product-description v-if="product" :product="product"></product-description>
            </div>
          </div>
        </div>
        <div id="product_specs" class="tab-pane fade">
          <div class="row align-items-center justify-content-center text-center m-t-lg m-b-lg">
            <div class="col-sm-12 col-xs-12 text-center m-b-md">
              <h5 class="text-u-c _400 product--title">product data</h5>
            </div>

                <div v-if="product.brand" class="col-xs-12 col-sm-6 col-md-4">
                  <span class="text-gray-888 text-ellipsis">Brand</span>
                  <p class="text-gray-888--details">{{ product.brand }}</p>
                </div>
                <div v-if="product.model" class="col-xs-12 col-sm-6 col-md-4">
                  <span class="text-gray-888 text-ellipsis">Model</span>
                  <p class="text-gray-888--details">{{ product.model }}</p>
                </div>
                <div v-if="product.sku" class="col-xs-12 col-sm-6 col-md-4">
                  <span class="text-gray-888 text-ellipsis">SKU</span>
                  <p class="text-gray-888--details">{{ product.sku }}</p>
                </div>
                <div v-if="product.category" class="col-xs-12 col-sm-6 col-md-4">
                  <span class="text-gray-888 text-ellipsis">Category</span>
                  <p class="text-gray-888--details">{{ product.category.name }}</p>
                </div>
                <div v-if="product.minimum_order_quantity" class="col-xs-12 col-sm-6 col-md-4">
                  <span class="text-gray-888 text-ellipsis">Minimum Order Quantity</span>
                  <p class="text-gray-888--details">{{ product.minimum_order_quantity }}</p>
                </div>
                <div v-if="product.requires_shipping || product.requires_shipping" class="col-xs-12 col-sm-6 col-md-4">
                  <span class="text-gray-888 text-ellipsis">Shipping Required</span>
                  <p class="text-gray-888--details" v-if="product.requires_shipping">Yes</p>
                  <p class="text-gray-888--details" v-else-if="product.requires_shipping">No</p>
                </div>
          </div>
          <hr class="tabs-divider" style="border-bottom: none;" />
          <div v-if="product.length || product.width || product.height || 
                    product.weight || product.shipping_length || product.shipping_length || 
                    product.shipping_height || product.shipping_weight" 
                    class="row align-items-center justify-content-center text-center product-dimensions m-t-lg m-b-lg">
            <div class="col-sm-12 col-xs-12 text-center m-b-md">
              <h5 class="text-u-c _400 product--title">product dimensions</h5>
            </div>

            <div class="product-dimensions__blocks-center">
              <!-- <div class="col-xs-12 col-sm-12 col-md-4 col-md-offset-2"> -->
                <div v-if="product.length || product.width || product.height" class="col-xs-12 col-sm-6 col-md-6">
                  <span class="text-gray-888 text-ellipsis">Product dimensions(cm)</span>
                  <p class="text-gray-888--details">{{ product.length }}<span v-if="product.length">L x</span> 
                                                    {{ product.width }}<span v-if="product.width">W x</span>
                                                    {{ product.height }}<span v-if="product.height">H</span>
                  </p>
                </div>
                <div v-if="product.weight" class="col-xs-12 col-sm-6 col-md-6">
                  <span class="text-gray-888 text-ellipsis">Product weight (kg)</span>
                  <p class="text-gray-888--details">{{ product.weight }}</p>
                </div>
              <!-- </div> -->

              <!-- <div class="col-xs-12 col-sm-12 col-md-4"> -->
                <div v-if="product.shipping_length || product.shipping_length || product.shipping_height" class="col-xs-12 col-sm-6 col-md-6">
                  <span class="text-gray-888 text-ellipsis">Shipping dimensions (cm)</span>
                  <p class="text-gray-888--details">{{ product.shipping_length }} {{ product.shipping_length }} {{ product.shipping_height }}</p>
                </div>
                <div v-if="product.shipping_weight" class="col-xs-12 col-sm-6 col-md-6">
                  <span class="text-gray-888 text-ellipsis">Shipping weight (kg)</span>
                  <p class="text-gray-888--details">{{ product.shipping_weight }}</p>
                </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <popular-products class="popular-products" :products="products"></popular-products>
  </div>
</template>

<script>

    import ProductDescription from '../components/product-description';
    import ProductFullView from '../components/product-full-view';
    import PopularProducts from '../components/popular-products'

    export default {
      name: "list",
      components: {
        ProductDescription,
        ProductFullView,
        PopularProducts
      },
      data() {
        return {
          product: null,
          products: null,
          loader: true
        }
      },
      created() {
        this.getProduct();
        this.getPopularProducts();
      },
      beforeRouteEnter (to, from, next) {
        next();
      },
      beforeRouteUpdate (to, from, next) {
        this.getProduct(to.params.id);
        this.getPopularProducts();
        next();
      },
      computed: {
      },
      watch: {
        product: function (to, from) {
          this.product = to;
        }
      },
      methods: {
        goBack(){
          this.$router.back();
        },
        getPopularProducts() {
          axios.get(`${window.marketplace.apiUrl}/products` + `?store_id=${window.marketplace.store_id}&status[]=10&status[]=70&sort=-view_count&per-page=4`)
            .then(res => {
              this.$store.dispatch('setPopularProducts', res.data.products).then(r => {
                this.loader = false;
                this.products = this.$store.getters.products;
              })
            })
        },
        getProduct(productId = null) {
          productId = productId ? productId : this.$route.params.id;
          axios.get(`${window.marketplace.apiUrl}/products/` + productId + '?expand=images,tags,category')
            .then(res => {
              this.$store.dispatch('setProduct', res.data.product).then(r => {
                this.loader = false;
                this.product = this.$store.getters.product;
              })
            })
        },
      }
    }
</script>

<style scoped>
  .product-full-view {
    padding-top: 12px;
  }

  .tabs-divider {
    border: 1px solid #dee2e6;
  }

  .text-u-c {
    font-size: 20px;
  }


  .popular-products {
    background-color: #fbfbfb;
    padding: 40px 0;
    position: relative;
    width: 140%;
    margin-left: -20%;
    margin-right: -20%;
    text-align: center;
  }
  #product_specs .justify-content-center {
    display: flex;
    flex-wrap: wrap; 
    justify-content: center !important;
  }
  #product_specs .align-items-center {
    align-items: center !important;
  }

  @media (min-width: 767.98px) {
    .popular-products {
      background-color: #fbfbfb;
      padding: 40px 0;
      position: relative;
      width: 120%;
      margin-left: -10%;
      margin-right: -10%;
      text-align: center;
    }
  }

  @media (min-width: 1023.98px) {
    .product-full-view-container {
      padding-left: 4.375rem;
      padding-right: 4.375rem;
    }
  }

  @media (max-width: 479px) {
    .products-page {
      padding-left: 0px;
      padding-right: 0px;
      margin-left: 0px;
      margin-right: 0px;
    }
    .m-b {
      margin-bottom: 0rem !important;
    }
  }
  .horizontal-line-above-tabset {
    margin-bottom: -0.5rem;
    height: 0.04rem;
    background-color: #797979;
  }
  .nav-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .go-back-btn {
    cursor: pointer;
    font-size: 12px;
    padding: 1rem;
  }
  .no-bg {
    background-color: transparent !important;
  }
  @media only screen and (min-width: 1200px){
    .nav-tabs {
      border-color: #ccc;
    }
    .nav-tabs .product--info {
      color: #999;
      font-size: 17px;
      background-color: transparent;
      padding: 13px 16px 6px;
      border: 1px solid transparent;
    }
    .nav-tabs .product--info:hover {
      border-color: rgba(120,130,140,.13);
      border-bottom-color: transparent;
    }
    .nav-tabs > li.active .product--info {
      color: #000;
      background-color: #ffffff;
      border-color: #ccc #ccc #fff !important;
    }
    .product--title {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.6;
    }
    .text-gray-888 {
      color: #888;
      font-size: 12px;
      font-weight: 400;
      font-family: Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif
    }
    .text-gray-888--details {
      color: rgba(0, 0, 0, 0.87);
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
    }
  }
  @media only screen and (max-width: 1199px) and (min-width: 768px){
    .nav-tabs {
      border-color: #ccc;
    }
    .nav-tabs .product--info {
      color: #999;
      font-size: 17px;
      background-color: transparent;
      padding: 13px 16px 6px;
      border: 1px solid transparent;
    }
    .nav-tabs .product--info:hover {
      border-color: rgba(120,130,140,.13);
      border-bottom-color: transparent;
    }
    .nav-tabs > li.active .product--info {
      color: #000;
      background-color: #ffffff;
      border-color: #ccc #ccc #fff !important;
    }
    .product--title {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.6;
    }
    .text-gray-888 {
      color: #888;
      font-size: 12px;
      font-weight: 400;
    }
    .text-gray-888--details {
      color: rgba(0, 0, 0, 0.87);
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
    }
  }
  @media only screen and (max-width: 767px){
    .nav-tabs {
      border-color: #ccc;
    }
    .nav-tabs .product--info {
      color: #999;
      font-size: 14px;
      background-color: transparent;
      padding: 13px 16px 6px;
      border: 1px solid transparent;
    }
    .nav-tabs .product--info:hover {
      border-color: rgba(120,130,140,.13);
      border-bottom-color: transparent;
    }
    .nav-tabs > li.active .product--info {
      color: #000;
      background-color: #ffffff;
      border-color: #ccc #ccc #fff !important;
    }
    .product--title {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.6;
    }
    .text-gray-888 {
      color: #888;
      font-size: 12px;
      font-weight: 400;
    }
    .text-gray-888--details {
      color: rgba(0, 0, 0, 0.87);
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
    }

  }
  @media only screen and (max-width: 480.98px){
  .product-full-view-container {
      padding-left: 0 !important;
    }
  }

</style>
